import Group from 'components/utils/Group'
import BedbankOfferPriceDetails from './BedbankOfferPriceDetails'
import WalledContent from 'components/Common/WalledContent'
import OfferTileLoggedInButtons from '../OfferListTiles/Support/OfferTileLoggedInButtons'
import { ViewOfferButton } from './ViewOfferButton'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate
  variant?: 'default' | 'condensed'
  selectedDatesAndRoomsFilter?: App.OfferListFilters
  filters?: App.OfferListFilters
  /**
   * Chat-carousel override: when provided, the price block and View button are
   * replaced by this CTA (e.g. a "Select dates" prompt for a no-date bedbank
   * offer whose price must be withheld). Defaults to the standard price + View.
   */
  CtaComponent?: React.ComponentType
}

function BedbankOfferCardPriceDetails(props: Props) {
  const { offer, variant = 'default', selectedDatesAndRoomsFilter, filters, CtaComponent } = props

  const wall =
    <OfferTileLoggedInButtons
      discountLabelAlign="end"
      align="right"
      fullWidth={false}
    />

  return <Group direction="horizontal" gap={8} horizontalAlign={CtaComponent ? 'end' : 'space-between'} verticalAlign="end">
    <WalledContent enforced={offer.walledGarden} hidePricing={offer.hidePricing} wall={wall}>
      {CtaComponent
        ? <CtaComponent />
        : <>
            <BedbankOfferPriceDetails offer={offer} selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter} filters={filters} />
            <ViewOfferButton variant={variant} />
        </>}
    </WalledContent>
  </Group>
}

export default BedbankOfferCardPriceDetails
